import React from "react";
import VehicleModelContainer from "../containers/Manufacturer/VehicleModel/index";

const VehicleModelPage = () => {
  return (
    <>
      <VehicleModelContainer />
    </>
  );
};

export default VehicleModelPage;
